import type { ModuleDef } from "../types";
import { defineModule } from "./define";

export const SUPPORT: ModuleDef[] = [
  defineModule({
    id: "radar_passive_mk1",
    name: "Passive Receiver Mk.I",
    category: "radar",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "radar_passive_mk1",
    stats: {
      mass: 140, hp: 40,
      tensile: 300_000_000,
      hardness: 0.2,
      powerIdleW: 200,
      thermalConductivity: 0.5,
      thermalEmissivity: 0.5,
    },
  }),
  defineModule({
    id: "radar_active_mk1",
    name: "Active Radar Mk.I",
    category: "radar",
    tier: 2,
    cells: { w: 1, h: 1 },
    sprite: "radar_active_mk1",
    stats: {
      mass: 260, hp: 50,
      tensile: 400_000_000,
      hardness: 0.25,
      powerActiveW: 4_000,
      thermalConductivity: 0.7,
      thermalEmissivity: 0.5,
    },
  }),
  defineModule({
    id: "radiator_mk1",
    name: "Heat Radiator Mk.I",
    category: "cooling",
    tier: 1,
    cells: { w: 1, h: 2 },
    sprite: "radiator_mk1",
    stats: {
      mass: 220, hp: 60,
      tensile: 200_000_000,
      hardness: 0.15,
      thermalConductivity: 2.4,
      thermalInertia: 900,
      thermalEmissivity: 0.95,
      surfaceAreaMult: 820,
      meltPointK: 2_500,
      crewTraversable: false,
    },
  }),
  defineModule({
    id: "cargo_bay_mk1",
    name: "Cargo Bay Mk.I",
    category: "cargo",
    tier: 1,
    cells: { w: 2, h: 2 },
    sprite: "cargo_bay_mk1",
    stats: {
      mass: 600, hp: 140,
      tensile: 400_000_000,
      hardness: 0.4,
      cargoCapacityKg: 12_000,
      thermalConductivity: 0.65,
      thermalEmissivity: 0.7,
    },
  }),
  defineModule({
    id: "collector_mk1",
    name: "Mass Collector Mk.I",
    category: "cargo",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "collector_mk1",
    stats: {
      mass: 180, hp: 50,
      tensile: 300_000_000,
      hardness: 0.4,
      powerIdleW: 120,
      thermalConductivity: 0.7,
      thermalEmissivity: 0.6,
    },
    collector: true,
  }),
  defineModule({
    id: "cargo_pod_mk1",
    name: "Cargo Pod Mk.I",
    category: "cargo",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "cargo_pod_mk1",
    stats: {
      mass: 200, hp: 70,
      tensile: 400_000_000,
      hardness: 0.4,
      cargoCapacityKg: 2_500,
      thermalConductivity: 0.65,
      thermalEmissivity: 0.7,
    },
  }),
  defineModule({
    id: "life_support_mk1",
    name: "Life Support Mk.I",
    category: "life_support",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "life_support_mk1",
    stats: {
      mass: 240, hp: 70,
      tensile: 350_000_000,
      hardness: 0.3,
      powerIdleW: 800,
      energyEfficiency: 0.5,
      thermalConductivity: 0.55,
      thermalEmissivity: 0.6,
      meltPointK: 1_200,
    },
  }),
  defineModule({
    id: "antenna_mk1",
    name: "Comms Antenna Mk.I",
    category: "radar",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "antenna_mk1",
    stats: {
      mass: 90, hp: 30,
      tensile: 200_000_000,
      hardness: 0.15,
      powerIdleW: 150,
      thermalConductivity: 0.7,
      thermalEmissivity: 0.4,
    },
  }),
  defineModule({
    id: "crew_quarters_mk1",
    name: "Crew Quarters Mk.I",
    category: "life_support",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "crew_quarters_mk1",
    stats: {
      mass: 380, hp: 80,
      tensile: 400_000_000,
      hardness: 0.4,
      powerIdleW: 300,
      thermalConductivity: 0.6,
      thermalEmissivity: 0.6,
      meltPointK: 1_400,
      crewCapacity: 4,
    },
  }),
  defineModule({
    id: "docking_collar_mk1",
    name: "Docking Collar Mk.I",
    category: "docking",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "docking_collar_mk1",
    stats: {
      mass: 320, hp: 90,
      tensile: 800_000_000,
      hardness: 0.7,
      powerIdleW: 250,
      thermalConductivity: 0.8,
      thermalEmissivity: 0.7,
    },
  }),
];
